<header class="app-header" role="banner" aria-label="Application Header">
  <a routerLink="/" aria-label="Go to homepage">
    <img src="assets/images/absa-logo.png" alt="ABSA Home" class="app-header__logo" />
  </a>

  <h1 class="app-header__title">Education Loan</h1>
</header>

<header class="app-header-2" role="banner" aria-label="Application Header">
  <a routerLink="/apply" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }"
    class="app-header-2__link">
    Apply
  </a>

  <a routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" class="app-header-2__link">
    How it works
  </a>
</header>